"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5 17h3l2-4V7H4v6h3zm10 0h3l2-4V7h-6v6h3z"
}), 'FormatQuoteSharp');